import axios from 'axios';
import { authHeader } from '../../helpers/auth-header';
import { buildUrl } from '../../helpers/Utils';
import Config from '../../config';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  CLIENT_SUPPORT_DELETE,
  CLIENT_SUPPORT_EDIT,
  CLIENT_SUPPORT_GET_BY_ID,
  CLIENT_SUPPORT_ADD_NEW,
  CLIENT_SUPPORT_GET_LIST,
  CLIENT_SUPPORT_LOG_LIST,
  CLIENT_SUPPORT_DELETE_ATTACHMENT,
  CLIENT_SUPPORT_REPORT,
} from './types';

import {
  getClientSupportListSuccess,
  getClientSupportListError,
  editClientSupportError,
  addNewClientSupportError,
  deleteClientSupportError,
  getClientSupportByIdSuccess,
  getClientSupportLogListSuccess,
  getClientSupportLogListError,
  deleteClientSupportAttachmentError,
  deleteClientSupportAttachmentSuccess,
  getClientSupportReportSuccess,
  getClientSupportReportError,
} from './actions';

const getClientSupportLogListRequest = async ClientSupportId => {
  return axios.get(
    `${Config.apiServerHost}/api/ClientSupport/log/${ClientSupportId}`,
    await authHeader()
  );
};

const getClientSupportListRequest = async query => {
  let url = `${Config.apiServerHost}/api/ClientSupport/fetch`;
  return await axios.get(buildUrl(url, query), await authHeader());
};

const addNewClientSupportReqeust = async ClientSupport => {
  return axios.post(`${Config.apiServerHost}/api/ClientSupport`, ClientSupport, await authHeader());
};

const editClientSupportRequest = async ClientSupport => {
  return axios.put(`${Config.apiServerHost}/api/ClientSupport`, ClientSupport, await authHeader());
};

const deleteClientSupportRequest = async id => {
  return axios.delete(`${Config.apiServerHost}/api/ClientSupport/${id}`, await authHeader());
};

const getClientSupportByIdRequest = async id => {
  return axios.get(`${Config.apiServerHost}/api/ClientSupport/${id}`, await authHeader());
};

const deleteClientSupportAttachmentRequest = async id => {
  return axios.delete(
    `${Config.apiServerHost}/api/ClientSupport/deleteAttachment/${id}`,
    await authHeader()
  );
};

const getSupportTypeRequest = async () => {
  return await axios.get(
    `${Config.apiServerHost}/api/ClientSupport/supportType`,
    await authHeader()
  );
};

const getSupportPaymentRequest = async () => {
  return await axios.get(
    `${Config.apiServerHost}/api/ClientSupport/supportPayment`,
    await authHeader()
  );
};

const getClientSupportReportRequest = async query => {
  let url = `${Config.apiServerHost}/api/ClientSupport/report`;
  return await axios.get(buildUrl(url, query), await authHeader());
};

function* getClientSupportList({ payload }) {
  try {
    const response = yield call(getClientSupportListRequest, payload);
    yield put(getClientSupportListSuccess(response.data));
  } catch (error) {
    yield put(getClientSupportListError(error.response.statusText));
  }
}

function* getClientSupportLogList({ payload }) {
  try {
    const response = yield call(getClientSupportLogListRequest, payload);
    yield put(getClientSupportLogListSuccess(response.data));
  } catch (error) {
    yield put(getClientSupportLogListError(error.response.statusText));
  }
}

function* addNewClientSupport({ payload }) {
  try {
    const { clientId, programId, servicePlanHeaderId, data } = payload;
    const query = {
      clientId,
      programId,
      servicePlanHeaderId,
    };

    yield call(addNewClientSupportReqeust, data);
    const response = yield call(getClientSupportListRequest, query);
    yield put(getClientSupportListSuccess(response.data));
  } catch (error) {
    yield put(addNewClientSupportError(error.response.statusText));
  }
}

function* editClientSupport({ payload }) {
  try {
    const { clientId, programId, servicePlanHeaderId, isEditReport, status, data } = payload;
    const query = {
      clientId: clientId ?? '',
      programId: programId ?? '',
      status: status ?? '',
      servicePlanHeaderId: servicePlanHeaderId ?? '',
    };

    let response = yield call(editClientSupportRequest, data);
    if (isEditReport) {
      response = yield call(getClientSupportReportRequest, query);
      yield put(getClientSupportReportSuccess(response.data));
    } else {
      response = yield call(getClientSupportListRequest, query);
      yield put(getClientSupportListSuccess(response.data));
    }
  } catch (error) {
    yield put(editClientSupportError(error.response.statusText));
  }
}

function* getClientSupportById({ payload }) {
  try {
    const response = yield call(getClientSupportByIdRequest, payload);
    yield put(getClientSupportByIdSuccess(response.data));
  } catch (error) {
    yield put(editClientSupportError(error.response.statusText));
  }
}

function* deleteClientSupport({ payload }) {
  try {
    const { programId, clientId, servicePlanHeaderId, isFromReport, status, data } = payload;
    const query = {
      programId,
      clientId,
      servicePlanHeaderId,
    };

    const query1 = {
      programId: programId ?? '',
      clientId: clientId ?? '',
      servicePlanHeaderId: servicePlanHeaderId ?? '',
      status: status ?? '',
    };

    let response = yield call(deleteClientSupportRequest, data);
    if (isFromReport) {
      response = yield call(getClientSupportReportRequest, query1);
      yield put(getClientSupportReportSuccess(response.data));
    } else {
      response = yield call(getClientSupportListRequest, query);
      yield put(getClientSupportListSuccess(response.data));
    }
  } catch (error) {
    yield put(deleteClientSupportError(error.response.statusText));
  }
}

function* deleteClientSupportAttachment({ payload }) {
  try {
    const response = yield call(deleteClientSupportAttachmentRequest, payload);
    yield put(deleteClientSupportAttachmentSuccess(response.data));
  } catch (error) {
    yield put(deleteClientSupportAttachmentError(error.response.statusText));
  }
}

function* getClientSupportReport({ payload }) {
  try {
    const response = yield call(getClientSupportReportRequest, payload);
    yield put(getClientSupportReportSuccess(response.data));
  } catch (error) {
    yield put(getClientSupportReportError(error.response.statusText));
  }
}

export function* watchClientSupportLogList() {
  yield takeEvery(CLIENT_SUPPORT_LOG_LIST, getClientSupportLogList);
}

export function* watchClientSupportList() {
  yield takeEvery(CLIENT_SUPPORT_GET_LIST, getClientSupportList);
}

export function* watchAddNewClientSupport() {
  yield takeEvery(CLIENT_SUPPORT_ADD_NEW, addNewClientSupport);
}

export function* watchClientSupportById() {
  yield takeEvery(CLIENT_SUPPORT_GET_BY_ID, getClientSupportById);
}

export function* watchEditClientSupport() {
  yield takeEvery(CLIENT_SUPPORT_EDIT, editClientSupport);
}

export function* watchDeleteClientSupport() {
  yield takeEvery(CLIENT_SUPPORT_DELETE, deleteClientSupport);
}

export function* watchDeleteClientSupportAttachment() {
  yield takeEvery(CLIENT_SUPPORT_DELETE_ATTACHMENT, deleteClientSupportAttachment);
}

export function* watchClientSupportReport() {
  yield takeEvery(CLIENT_SUPPORT_REPORT, getClientSupportReport);
}

export default function* rootSaga() {
  yield all([
    fork(watchClientSupportLogList),
    fork(watchClientSupportList),
    fork(watchAddNewClientSupport),
    fork(watchClientSupportById),
    fork(watchEditClientSupport),
    fork(watchDeleteClientSupport),
    fork(watchDeleteClientSupportAttachment),
    fork(watchClientSupportReport),
  ]);
}

export {
  getSupportTypeRequest,
  getSupportPaymentRequest,
  getClientSupportByIdRequest,
  editClientSupportRequest,
};
